<template>
    <div class="ma-1">
        <app-crumps v-if="journal == null" :crumps="crumps" class="ml-n2"></app-crumps>
        <p class="text-subtitle-1 my-3  font-weight-black">
           Instructions for authors
           <v-btn v-if="bo" x-small class="mt-1 ml-2 white--text" color="green darken-4"
                :to="{name:'journal.edit.bo',params:{id:this.$route.params.journal_id,model:'Instructions'}}" >
                edit
            </v-btn>
        </p>
        <div class="ql-ed" >
            <span v-html ="instructions"></span>
        </div>
    </div>
</template>
<script>

import {mapGetters} from 'vuex';
import CrumpsVue from '../../sharing/Crumps.vue';
import router from '../../../router';
export default {
     props:{
        bo: {
            type:Boolean,
            default:false
        },
    },
    data() {
        return{
            instructions:null,
            crumps:[],
        }
    },
    components:{
        appCrumps: CrumpsVue,
    },
    created() {
        this.getInstructions();
        this.getCrumpsData();

    },
    computed:{
        ...mapGetters('library',{
            journal:'journal',
        })
    },
    methods: {
        getCrumpsData(){
            if(this.journal != null){
                return null;
            }
            else{
                this.getCrumps();
            }
        },
        async getInstructions(){
            try{
                const res = await axios.get('/index.php/api/library/journals/instructions/'+this.$route.params.journal_id );
                if(res){
                    this.instructions = res.data;
                }
            } catch (error) {
                throw error;
            }
        },
        async getCrumps(){
            try{
                const res = await axios.get('/index.php/api/library/journals/title/'+this.$route.params.journal_id );
                if(res){
                    this.crumps.push({
                        text:"home.title",
                        disabled: false,
                        href: 'home'
                    });
                    this.crumps.push({
                        text: res.data,
                        disabled: false,
                        href: 'journal',
                        params:{journal_id:this.$route.params.journal_id},
                    }),
                    this.crumps.push({
                        text: 'Instructions for authors',
                        disabled: true,
                        href: ''
                    });
                }
            } catch (error) {
                throw error;
            }
        }
    },
}
</script>
